module.exports = __webpack_public_path__ + "img/sym4.0ecd63dd.png";